import { OFFERSPERREQUEST } from "./config";
import { filteredProperties, setAppliedSearchfilters, setFilterqueryid } from "./filterSlice";

import {
  availabilityAndPriceCheck,
  availabilityAndPriceCheckBestValue,
  availabilityAndPriceCheckLowestPrice,
  availabilityAndPriceCheckPremium,
  availabilityAndPriceCheck as availabilityAndPriceCheckSlice,
  checkHotelActions,
  checkHotelActionsBestValue,
  checkHotelActionsLowestPrice,
  checkHotelActionsPremium,
  searchBestValueOffers,
  searchHotelOffers,
  searchLowestPriceOffers,
  searchPremiumOffers,
  setDoAvailabilityCheck,
  setDoAvailabilityCheckBestValue,
  setDoAvailabilityCheckPremium,
  setHotelData,
  setHotelOfferInfos,
  setHotelPage,
  setOfferId,
  setSelectedHotel,
} from "./hotelSlice";
import {
  availabilityAndPriceCheckDesired,
  availabilityAndPriceCheckOffer,
  availabilityAndPriceCheckRecommended,
  checkActions,
  checkActionsDesired,
  checkActionsRecommended,
  searchDesiredHotels,
  searchOffers,
  searchRecommendedHotels,
  sendQuery,
  setDesiredInfos,
  setMemo,
  setOfferqueryid,
  setRecommendedInfos,
} from "./offersSlice";
import { adultsOptions, airportcity, childrenAgeOptions, childrenOptions, durationOptions, durationkindOptions, getHost, printError } from "./utils";

import { v4 as uuidv4 } from "uuid";
import { setInbounddate, setOutbounddate, setQueryid, setSearchOption, setSelectedDestination } from "./searchSlice";
import { AppViews } from "../utils";
import { getAppStore } from "../app/storeRegistry";
import { setSearchReducer } from "./systemSlice";
import { getGiataGallery, getHolidaycheckOverall } from "./cacheSlice";

export const getLink2Share = (id, sessionId, hotelOfferInfos, offer) => {
  let hf = {};
  if (hotelOfferInfos && offer) {
    hf = {
      ...hotelOfferInfos,
      Offers: { ...hotelOfferInfos.Offers },
      HotelDictionary: { Hotel: [...hotelOfferInfos.HotelDictionary.Hotel] },
    };
    hf.Offers.OfferCount = 1;
    let off = { ...offer };
    delete off.bookinginfo;
    hf.Offers.Offer = [{ ...off }];
    let hotels = hf.HotelDictionary;

    const hotel = hotels ? hotels.Hotel.find((e) => e.HotelID === offer?.OfferServices?.Package?.Accommodation?.HotelRef?.HotelID) : {};
    hf.HotelDictionary.Hotel = [{ ...hotel }];
  }

  return fetch(getHost() + "/getlink2share", {
    method: "post",
    headers: new Headers({
      "content-type": "application/json",
    }),
    body: JSON.stringify({
      sessionid: sessionId,
      offerid: id,
      url: window.location.href,
      infos: hf,
    }),
  });
};

export const setOfferMemo = (id, giataid, sessionId, dispatch, hotelOfferInfos, offer) => {
  let hf = {};
  if (hotelOfferInfos && offer) {
    hf = {
      ...hotelOfferInfos,
      Offers: { ...hotelOfferInfos.Offers },
      HotelDictionary: { Hotel: [...hotelOfferInfos.HotelDictionary.Hotel] },
    };
    hf.Offers.OfferCount = 1;
    let off = { ...offer };
    delete off.bookinginfo;
    hf.Offers.Offer = [{ ...off }];
    let hotels = hf.HotelDictionary;

    const hotel = hotels ? hotels.Hotel.find((e) => e.HotelID === offer?.OfferServices?.Package?.Accommodation?.HotelRef?.HotelID) : {};
    hf.HotelDictionary.Hotel = [{ ...hotel }];
  }

  try {
    fetch(getHost() + "/offermemo", {
      method: "post",
      headers: new Headers({
        "content-type": "application/json",
      }),
      body: JSON.stringify({
        session_id: sessionId,
        offer_id: id,
        giata_id: giataid,
        offer_infos: hf,
        url: window.location.href,
      }),
    })
      .then((response) => response.json())
      .then(() => getSessionMemo(id, sessionId, dispatch));
  } catch (e) {
    console.log(e);
  }
};

export const getSessionMemo = (id, sessionId, dispatch) => {
  try {
    console.log("getSessionMemo called with sessionId:", sessionId);
    fetch(getHost() + "/sessionmemo?sessionid=" + sessionId)
      .then((response) => response.json())
      .then((data) => {
        console.log("getSessionMemo response:", data);
        const memoData = data.memos;
        if (Array.isArray(memoData)) {
          console.log("getSessionMemo memo offers:", memoData);
          dispatch(setMemo(memoData));
        } else {
          console.log("getSessionMemo: no valid memo data found", data);
        }
      })
      .catch((error) => {
        console.error("getSessionMemo Error:", error);
      });
  } catch (e) {
    console.log("getSessionMemo catch error:", e);
  }
};

export const getFilters = (dispatch, hotel, touristicRegions) => {
  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "TouristicRegions",
      update: {},
      touristicRegions: touristicRegions,
    }),
  );

  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "TourOperator",
      update: { tourOperators: [] },
    }),
  );

  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "DestinationStations",
      update: { destinationStations: [] },
    }),
  );

  /*dispatch(
    filteredProperties({
      hotel: hotel,
      property: "All",
      update: { airlines: [] },
    })
  );*/

  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "BoardTypes",
      update: { boardType: [] },
    }),
  );

  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "RoomView",
      update: { roomView: [] },
    }),
  );

  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "RoomType",
      update: { roomType: [] },
    }),
  );

  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "HotelAttributes",
      update: {},
    }),
  );

  try {
    return dispatch(
      filteredProperties({
        hotel: hotel,
        property: "TransportOperatingBrand",
        update: {
          operatingbrand: [],
          inbounddate: "",
          outbounddate: "",
        },
      }),
    );
  } catch (e) {
    console.log(e);
  }
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const applyNextReduction = (searchReducer, state, dispatch) => {
  const reducer = searchReducer.map((c) => ({ ...c }));
  for (let i = 0; i < reducer.length; i++) {
    const criterion = reducer[i];
    if (criterion.done) continue;
    const applied = criterion.applied ?? 0;
    if (criterion.property === "duration") {
      const durStr = String(state.search?.duration?.value ?? "");
      const hasDash = durStr.includes("-");
      if (hasDash) {
        const [minStr, maxStr] = durStr.split("-");
        const min = parseInt(minStr);
        const max = parseInt(maxStr);
        const newMin = min - 1;
        if (newMin >= 2) {
          dispatch(setSearchOption({ property: "duration", data: { value: `${newMin}-${max}`, label: state.search?.duration?.label } }));
          const newApplied = applied - 1;
          reducer[i].applied = newApplied;
          reducer[i].newValue = `${newMin}-${max}`;
          if (newApplied <= criterion.offset) reducer[i].done = true;
          return reducer;
        }
      } else {
        const durVal = parseInt(durStr);
        if (!isNaN(durVal)) {
          const newMin = durVal - 1;
          if (newMin >= 2) {
            dispatch(setSearchOption({ property: "duration", data: { value: `${newMin}-${durVal}`, label: state.search?.duration?.label } }));
            const newApplied = applied - 1;
            reducer[i].applied = newApplied;
            reducer[i].newValue = `${newMin}-${durVal}`;
            if (newApplied <= criterion.offset) reducer[i].done = true;
            return reducer;
          }
        }
      }
      reducer[i].done = true;
      continue;
    }
    if (criterion.property === "category") {
      const catVal = parseInt(String(state.search?.category ?? ""));
      if (!isNaN(catVal) && catVal > 0) {
        const newVal = catVal - 1;
        if (newVal >= 0) {
          dispatch(setSearchOption({ property: "category", data: String(newVal) }));
          const newApplied = applied - 1;
          reducer[i].applied = newApplied;
          reducer[i].newValue = newVal;
          if (newApplied <= criterion.offset) reducer[i].done = true;
          return reducer;
        }
      }
      reducer[i].done = true;
      continue;
    }
    if (criterion.property === "directflight") {
      if (state.search?.directflight === true) {
        dispatch(setSearchOption({ property: "directflight", data: false }));
        reducer[i].applied = true;
        reducer[i].done = true;
        return reducer;
      }
      reducer[i].done = true;
      continue;
    }
  }
  return null;
};

export const search = (dispatch, hotel, offset, queryid, touristicRegions, keepAppliedSearchFilters, manualSearch = false) => {
  if (!offset) {
    offset = 0;
    if (!queryid) queryid = uuidv4();  // vorgegebene queryid respektieren (KIsha loggt sie)
    dispatch(setQueryid(queryid));
    dispatch(setFilterqueryid(queryid));
    dispatch(setOfferqueryid(queryid));

    const params = new URLSearchParams(window.location.search);
    let view = params.get("v");
    if (!view) view = AppViews.SECTION;
    // SEO-Slug nach der ersten Suche IMMER aus dem Pfad entfernen (absolute "/?id=").
    // Sobald eine Suche gelaufen ist, ist die UUID-queryid das funktionale Ziel —
    // ein veralteter Slug darf das frische ?id nicht mehr ueberschreiben (App.jsx
    // gibt dem Slug-Pfad sonst Vorrang vor ?id).
    // Der Testschalter ?kisha= ueberlebt das Umschreiben, sonst waere er nach der
    // ersten Suche aus der URL verschwunden und nicht mehr teilbar.
    const kishaParam = params.get("kisha");
    window.history.replaceState({}, "", "/?id=" + queryid + (view ? "&v=" + view : "") + (kishaParam ? "&kisha=" + encodeURIComponent(kishaParam) : ""));
  }
  if (manualSearch) {
    dispatch(setSearchReducer([]));
  }
  if (!keepAppliedSearchFilters) {
    dispatch(setAppliedSearchfilters({}));
  }

  if (!offset > 0) {
    getFilters(dispatch, hotel, touristicRegions);
  }
  if (hotel) {
    const state = getAppStore().getState();
    const view = state.system.view;
    if (view == AppViews.CROSSCHECK) {
      dispatch(searchHotelOffers({ offset: offset, cross: true })).then((data) => {
        if (data?.payload?.error) {
          printError(data.payload.error);
          return;
        }

        const offers = data?.payload?.Offers?.Offer || [];

        if (data?.payload?.RS_Metadata?.TransactionID && data?.payload?.RS_Metadata?.TransactionID !== queryid) return;

        if (data?.payload?.Offers?.MoreOffersAvailable) {
          search(dispatch, hotel, offset + 200, queryid, touristicRegions, keepAppliedSearchFilters, manualSearch);
        }

        if (data?.payload?.Offers?.OfferCount > 0 && offset === 0) {
          //TODO weiter Aktionen
        } else {
          if (offset === 0) printError("Kein passendes Angebot gefunden");
        }
      });
    } else {
      window.classicscrollock = true;

      setTimeout(() => {
        window.classicscrollock = false;
      }, 3000);

      if (offset === 0) {
        dispatch(searchLowestPriceOffers({ offset: offset })).then((data) => {
          if (data?.payload?.error) {
            printError(data.payload.error);
            return;
          }

          const offers = data?.payload?.Offers?.Offer || [];

          offers.forEach(async (offer) => {
            await sleep(10);
            let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
            let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

            dispatch(
              checkHotelActionsLowestPrice({
                offer: {
                  ...offer,
                  hotel: hotel,
                  city: city,
                },
                agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
              }),
            );
          });

          (async () => {
            dispatch(setDoAvailabilityCheck(true));
            const EARLY_RENDER_BATCH = 5;
            let completed = 0;
            let flagCleared = false;
            const promises = offers.map(async (offer) => {
              await sleep(10);

              let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);

              await dispatch(
                availabilityAndPriceCheckLowestPrice({
                  OfferID: offer.OfferID,
                  offer: offer,
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                }),
              );
              completed += 1;
              if (!flagCleared && (completed >= EARLY_RENDER_BATCH || completed >= offers.length)) {
                flagCleared = true;
                dispatch(setDoAvailabilityCheck(false));
              }
            });

            await Promise.all(promises);
            if (!flagCleared) dispatch(setDoAvailabilityCheck(false));
          })();

          if (data?.payload?.RS_Metadata?.TransactionID && data?.payload?.RS_Metadata?.TransactionID !== queryid) return;

          if (data?.payload?.Offers?.OfferCount > 0 && offset === 0) {
            // no action
          } else {
            if (offset === 0) printError("Kein passendes Angebot gefunden");
          }
        });
      }
      if (offset === 0 && state.search.activeMode == "PAC") {
        dispatch(searchBestValueOffers({ offset: offset })).then((data) => {
          if (data?.payload?.error) {
            printError(data.payload.error);
            return;
          }

          const offers = data?.payload?.Offers?.Offer || [];

          offers.forEach(async (offer) => {
            await sleep(10);
            let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
            let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

            dispatch(
              checkHotelActionsBestValue({
                offer: {
                  ...offer,
                  hotel: hotel,
                  city: city,
                },
                agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
              }),
            );
          });

          (async () => {
            dispatch(setDoAvailabilityCheckBestValue(true));
            const EARLY_RENDER_BATCH = 5;
            let completed = 0;
            let flagCleared = false;
            const promises = offers.map(async (offer) => {
              await sleep(10);

              let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);

              await dispatch(
                availabilityAndPriceCheckBestValue({
                  OfferID: offer.OfferID,
                  offer: offer,
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                }),
              );
              completed += 1;
              if (!flagCleared && (completed >= EARLY_RENDER_BATCH || completed >= offers.length)) {
                flagCleared = true;
                dispatch(setDoAvailabilityCheckBestValue(false));
              }
            });

            await Promise.all(promises);
            if (!flagCleared) dispatch(setDoAvailabilityCheckBestValue(false));
          })();

          if (data?.payload?.RS_Metadata?.TransactionID && data?.payload?.RS_Metadata?.TransactionID !== queryid) return;

          if (data?.payload?.Offers?.OfferCount > 0 && offset === 0) {
            // no action
          } else {
            if (offset === 0) printError("Kein passendes Angebot gefunden");
          }
        });
      }
      if (offset === 0 && state.search.activeMode == "PAC" && (!state.search.transferincluded || !state.search.addablecancellation)) {
        dispatch(searchPremiumOffers({ offset: offset })).then((data) => {
          if (data?.payload?.error) {
            printError(data.payload.error);
            return;
          }

          const offers = data?.payload?.Offers?.Offer || [];

          offers.forEach(async (offer) => {
            await sleep(10);
            let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
            let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

            dispatch(
              checkHotelActionsPremium({
                offer: {
                  ...offer,
                  hotel: hotel,
                  city: city,
                },
                agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
              }),
            );
          });

          (async () => {
            dispatch(setDoAvailabilityCheckPremium(true));
            const EARLY_RENDER_BATCH = 5;
            let completed = 0;
            let flagCleared = false;
            const promises = offers.map(async (offer) => {
              await sleep(10);

              let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);

              await dispatch(
                availabilityAndPriceCheckPremium({
                  OfferID: offer.OfferID,
                  offer: offer,
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                }),
              );
              completed += 1;
              if (!flagCleared && (completed >= EARLY_RENDER_BATCH || completed >= offers.length)) {
                flagCleared = true;
                dispatch(setDoAvailabilityCheckPremium(false));
              }
            });

            await Promise.all(promises);
            if (!flagCleared) dispatch(setDoAvailabilityCheckPremium(false));
          })();

          if (data?.payload?.RS_Metadata?.TransactionID && data?.payload?.RS_Metadata?.TransactionID !== queryid) return;

          if (data?.payload?.Offers?.OfferCount > 0 && offset === 0) {
            // no action
          } else {
            if (offset === 0) printError("Kein passendes Angebot gefunden");
          }
        });
      }

      dispatch(searchHotelOffers({ offset: offset })).then((data) => {
        if (data?.payload?.error) {
          printError(data.payload.error);
          return;
        }

        const offers = data?.payload?.Offers?.Offer || [];

        offers.forEach(async (offer) => {
          await sleep(1);
          let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
          let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

          dispatch(
            checkHotelActions({
              offer: {
                ...offer,
                hotel: hotel,
                city: city,
              },
              agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
            }),
          );
        });

        (async () => {
          const promises = offers.map(async (offer) => {
            await sleep(1);

            let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);

            await dispatch(
              availabilityAndPriceCheck({
                OfferID: offer.OfferID,
                offer: offer,
                HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
              }),
            );
          });

          await Promise.all(promises);
        })();

        if (data?.payload?.RS_Metadata?.TransactionID && data?.payload?.RS_Metadata?.TransactionID !== queryid) return;

        if (data?.payload?.Offers?.OfferCount > 0 && offset === 0) {
          //TODO weiter Aktionen
        } else {
          if (offset === 0) printError("Kein passendes Angebot gefunden");
        }
      });
    }
  } else {
    const state = getAppStore().getState();
    if (offset == 0) {
      dispatch(sendQuery({ offset: offset }));
      if (Array.isArray(state.offers.recommendedHotels) && state.offers.recommendedHotels.length > 0) {
        dispatch(searchRecommendedHotels({ offset: offset })).then((data) => {
          if (data?.payload?.error) {
            printError(data.payload.error);
            return;
          }

          // console.log(data?.payload);
          const offers = data?.payload?.Offers?.Offer || [];

          offers.forEach(async (offer) => {
            await sleep(1);
            let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
            let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

            dispatch(
              checkActionsRecommended({
                offer: {
                  ...offer,
                  hotel: hotel,
                  city: city,
                },
                agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
              }),
            );
            if (!state.cache.holidaycheckOverall[hotel?.HotelCodes?.HotelGiataID]) {
              dispatch(
                getHolidaycheckOverall({
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                }),
              );
            }
            if (!state.cache.giataSmallGalleries[hotel?.HotelCodes?.HotelGiataID]) {
              dispatch(
                getGiataGallery({
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                  giataoperators: state.filter.giataoperators,
                }),
              );
            }
            if (state.search?.children?.value * 1 > 0) {
              dispatch(
                availabilityAndPriceCheckRecommended({
                  OfferID: offer.OfferID,
                  offer: offer,
                  HotelGiataID: hotel.HotelCodes.HotelGiataID,
                }),
              );
            }
          });

          if (!(data?.payload?.Offers?.OfferCount > 0 && offset === 0)) {
            if (offset === 0) printError("Kein recommended Angebot gefunden");
          }
        });
      } else {
        dispatch(setRecommendedInfos({}));
      }
      if (Array.isArray(state.search.desiredHotels) && state.search.desiredHotels.length > 0) {
        dispatch(searchDesiredHotels({ offset: offset })).then((data) => {
          if (data?.payload?.error) {
            printError(data.payload.error);
            return;
          }

          // console.log(data?.payload);
          const offers = data?.payload?.Offers?.Offer || [];

          offers.forEach(async (offer) => {
            await sleep(1);
            let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
            let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

            dispatch(
              checkActionsDesired({
                offer: {
                  ...offer,
                  hotel: hotel,
                  city: city,
                  agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
                },
              }),
            );

            if (!state.cache.holidaycheckOverall[hotel?.HotelCodes?.HotelGiataID]) {
              dispatch(
                getHolidaycheckOverall({
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                }),
              );
            }
            if (!state.cache.giataSmallGalleries[hotel?.HotelCodes?.HotelGiataID]) {
              dispatch(
                getGiataGallery({
                  HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
                  giataoperators: state.filter.giataoperators,
                }),
              );
            }

            if (state.search?.children?.value * 1 > 0) {
              dispatch(
                availabilityAndPriceCheckDesired({
                  OfferID: offer.OfferID,
                  offer: offer,
                  HotelGiataID: hotel.HotelCodes.HotelGiataID,
                }),
              );
            }
          });

          if (!(data?.payload?.Offers?.OfferCount > 0 && offset === 0)) {
            if (offset === 0) printError("Kein recommended Angebot gefunden");
          }
        });
      } else {
        dispatch(setDesiredInfos({}));
      }
    }

    dispatch(searchOffers({ offset: offset })).then((data) => {
      if (data?.payload?.error) {
        printError(data.payload.error);
        return;
      }

      // console.log(data?.payload);
      const offers = data?.payload?.Offers?.Offer || [];

      offers.forEach(async (offer) => {
        await sleep(1);
        let hotel = data?.payload?.HotelDictionary?.Hotel?.find((e) => e.HotelID == offer.OfferServices.Package.Accommodation.HotelRef.HotelID);
        let city = data?.payload?.GeoDictionary?.Cities?.City?.find((e) => e.CityID == hotel?.HotelLocationRef?.CityID);

        dispatch(
          checkActions({
            offer: {
              ...offer,
              hotel: hotel,
              city: city,
            },
            agencypictures: !state.cache.agencyPictures[hotel?.HotelCodes?.HotelGiataID],
          }),
        );
        if (!state.cache.holidaycheckOverall[hotel?.HotelCodes?.HotelGiataID]) {
          dispatch(
            getHolidaycheckOverall({
              HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
            }),
          );
        }
        if (!state.cache.giataSmallGalleries[hotel?.HotelCodes?.HotelGiataID]) {
          dispatch(
            getGiataGallery({
              HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
              giataoperators: state.filter.giataoperators,
            }),
          );
        }
        if (state.search?.children?.value * 1 > 0) {
          dispatch(
            availabilityAndPriceCheckOffer({
              OfferID: offer.OfferID,
              offer: offer,
              HotelGiataID: hotel.HotelCodes.HotelGiataID,
            }),
          );
        }
      });
      //console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!pl", data?.payload?.Offers?.OfferCount);
      if (!(data?.payload?.Offers?.OfferCount > 0 && offset === 0)) {
        if (offset === 0) {
          const currentState = getAppStore().getState();
          const updatedReducer = applyNextReduction(currentState.system.searchReducer, currentState, dispatch);
          if (updatedReducer) {
            dispatch(setSearchReducer(updatedReducer));
            search(dispatch, hotel, 0, undefined, touristicRegions, keepAppliedSearchFilters, manualSearch);
          } else {
            printError("Kein passendes Angebot gefunden");
          }
        }
      }
    });
  }
};

export const getTourOperatorsForHotel = (hotel, dispatch, firstcall) => {
  dispatch(
    filteredProperties({
      hotel: hotel,
      property: "TourOperatorsForHotel",
      firstcall: firstcall,
      update: {},
    }),
  )
    .then((data) => {
      if (Array.isArray(data?.payload?.TourOperatorsForHotels?.TourOperatorsForHotel) && data.payload.TourOperatorsForHotels.TourOperatorsForHotel.length > 0) {
        getTourOperatorsForHotel(hotel, dispatch, false);
      } else {
        //dispatch(queryOrderPlus());
      }
    })
    .catch((e) => {
      console.log(e);
    });
};

export const memotosearch = (data, dispatch) => {
  let dat = Array.isArray(data.ret) && data.ret.length > 0 ? data.ret[0] : {};
  if (dat?.data) dat = dat.data;

  let hotelsearch = false;
  if (dat.HotelGiataID) {
    //console.log("HotelGiataID");
    dispatch(
      setSelectedHotel({
        label: dat.HotelName ? dat.HotelName : "Favorit",
        HotelCodes: {
          HotelGiataID: dat.HotelGiataID * 1,
          label: dat.HotelName ? dat.HotelName : "Favorit",
          value: dat.HotelName ? dat.HotelName : "Favorit",
          Name: dat.HotelName ? dat.HotelName : "Favorit",
        },
      }),
    );
    dispatch(
      setSelectedDestination([
        {
          label: dat.HotelName ? dat.HotelName : "Favorit",
          HotelID: dat.HotelGiataID * 1,
          HotelCodes: {
            HotelGiataID: dat.HotelGiataID * 1,
            label: dat.HotelName ? dat.HotelName : "Favorit",
            value: dat.HotelName ? dat.HotelName : "Favorit",
            Name: dat.HotelName ? dat.HotelName : "Favorit",
          },
        },
      ]),
    );
    hotelsearch = true;
  } else {
    if (Array.isArray(dat.request.HotelGiataID) && dat.request.HotelGiataID.length > 1) {
      dispatch(
        setSelectedDestination(
          dat.request.HotelGiataID.map((e, i) => {
            return {
              label:
                Array.isArray(dat.request.HotelGiataID) && Array.isArray(dat.request.HotelName) && dat.request.HotelName.length === dat.request.HotelGiataID.length
                  ? dat.request.HotelName[i]
                  : "Favorit",
              HotelCodes: {
                HotelGiataID: e * 1,
                label:
                  Array.isArray(dat.request.HotelGiataID) && Array.isArray(dat.request.HotelName) && dat.request.HotelName.length === dat.request.HotelGiataID.length
                    ? dat.request.HotelName[i]
                    : "Favorit",
                value:
                  Array.isArray(dat.request.HotelGiataID) && Array.isArray(dat.request.HotelName) && dat.request.HotelName.length === dat.request.HotelGiataID.length
                    ? dat.request.HotelName[i]
                    : "Favorit",
                Name:
                  Array.isArray(dat.request.HotelGiataID) && Array.isArray(dat.request.HotelName) && dat.request.HotelName.length === dat.request.HotelGiataID.length
                    ? dat.request.HotelName[i]
                    : "Favorit",
              },
            };
          }),
        ),
      );
    } else {
      if (Array.isArray(dat.request.CityID)) {
        dispatch(
          setSelectedDestination(
            dat.request.CityID.map((e, i) => {
              return {
                CityID: e * 1,
                label: Array.isArray(dat.request.CityID) && Array.isArray(dat.request.CityName) && dat.request.CityName.length === dat.request.CityID.length ? dat.request.CityName[i] : "Favorit",
                value: Array.isArray(dat.request.CityID) && Array.isArray(dat.request.CityName) && dat.request.CityName.length === dat.request.CityID.length ? dat.request.CityName[i] : "Favorit",
                Name: Array.isArray(dat.request.CityID) && Array.isArray(dat.request.CityName) && dat.request.CityName.length === dat.request.CityID.length ? dat.request.CityName[i] : "Favorit",
              };
            }),
          ),
        );
      } else {
        if (dat.HotelCityID) {
          dispatch(
            setSelectedDestination([
              {
                CityID: dat.HotelCityID * 1,
                label: dat.CityName ? dat.CityName : "Favorit",
                value: dat.CityName ? dat.CityName : "Favorit",
                Name: dat.CityName ? dat.CityName : "Favorit",
              },
            ]),
          );
        } else {
          if (Array.isArray(dat.request.RegionID)) {
            dispatch(
              setSelectedDestination(
                dat.request.RegionID.map((e, i) => {
                  return {
                    RegionID: e * 1,
                    label:
                      Array.isArray(dat.request.RegionID) && Array.isArray(dat.request.RegionName) && dat.request.RegionName.length === dat.request.RegionID.length
                        ? dat.request.RegionName[i]
                        : "Favorit",
                    value:
                      Array.isArray(dat.request.RegionID) && Array.isArray(dat.request.RegionName) && dat.request.RegionName.length === dat.request.RegionID.length
                        ? dat.request.RegionName[i]
                        : "Favorit",
                    Name:
                      Array.isArray(dat.request.RegionID) && Array.isArray(dat.request.RegionName) && dat.request.RegionName.length === dat.request.RegionID.length
                        ? dat.request.RegionName[i]
                        : "Favorit",
                  };
                }),
              ),
            );
          } else {
            if (dat.HotelRegionID) {
              dispatch(
                setSelectedDestination([
                  {
                    RegionID: dat.HotelRegionID * 1,
                    label: dat.RegionName ? dat.RegionName : "Favorit",
                    value: dat.RegionName ? dat.RegionName : "Favorit",
                    Name: dat.RegionName ? dat.RegionName : "Favorit",
                  },
                ]),
              );
            } else {
              if (Array.isArray(dat.request.RegionGroupID) && dat.request.RegionGroupID.length > 1) {
                dispatch(
                  setSelectedDestination(
                    dat.request.RegionGroupID.map((e, i) => {
                      return {
                        RegionGroupID: e * 1,
                        label:
                          Array.isArray(dat.request.RegionGroupID) && Array.isArray(dat.request.RegionName) && dat.request.RegionName.length === dat.request.RegionGroupID.length
                            ? dat.request.RegionName[i]
                            : "Favorit",
                        value:
                          Array.isArray(dat.request.RegionGroupID) && Array.isArray(dat.request.RegionName) && dat.request.RegionName.length === dat.request.RegionGroupID.length
                            ? dat.request.RegionName[i]
                            : "Favorit",
                        Name:
                          Array.isArray(dat.request.RegionGroupID) && Array.isArray(dat.request.RegionName) && dat.request.RegionName.length === dat.request.RegionGroupID.length
                            ? dat.request.RegionName[i]
                            : "Favorit",
                      };
                    }),
                  ),
                );
              } else {
                dispatch(
                  setSelectedDestination([
                    {
                      RegionGroupID: dat.request.RegionGroupID * 1,
                      label: dat.RegionName ? dat.RegionName : "Favorit",
                      value: dat.RegionName ? dat.RegionName : "Favorit",
                      Name: dat.RegionName ? dat.RegionName : "Favorit",
                    },
                  ]),
                );
              }
            }
          }
        }
      }
    }
  }
  if (dat.request.minDate) {
    let td = {
      from: JSON.stringify(new Date(dat.request.minDate)),
      to: JSON.stringify(new Date(dat.request.maxDate)),
    };
    dispatch(setSearchOption({ property: "travelDate", data: td }));
  }

  //console.log("REQUEST", dat.request);

  if (dat.request.outbounddate) {
    let td = {
      from: JSON.stringify(new Date(dat.request.outbounddate)),
      to: JSON.stringify(new Date(dat.request.inbounddate ? dat.request.inbounddate : dat.request.maxDate)),
    };
    dispatch(setSearchOption({ property: "travelDate", data: td }));
  }

  if (dat.request.adults)
    dispatch(
      setSearchOption({
        property: "adults",
        data: adultsOptions.find((o) => o.value === dat.request.adults + ""),
      }),
    );
  if (dat.request.children) {
    dispatch(
      setSearchOption({
        property: "children",
        data: childrenOptions.find((o) => o.value === dat.request.children + ""),
      }),
    );

    if (dat.request.childrenages) {
      let childrenages = [
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
      ];

      let tmpages = [];
      if (Array.isArray(dat.request.childrenages)) {
        tmpages = [...dat.request.childrenages];
      } else {
        tmpages = dat.request.childrenages.split(",");
      }
      if (Array.isArray(tmpages)) {
        for (let i = 0; i < tmpages.length; i++) {
          childrenages[i] = childrenAgeOptions.find((o) => o.value === tmpages[i] + "");
        }
      }
      dispatch(
        setSearchOption({
          property: "childrenages",
          data: childrenages,
        }),
      );
    }
  }

  if (dat.request.touroperators) {
    dispatch(
      setSearchOption({
        property: "tourOperators",
        data: dat.request.touroperators.split(","),
      }),
    );
  }
  if (dat.request.hotelAttribute) {
    if (!Array.isArray(dat.request.hotelAttribute)) dat.request.hotelAttribute = JSON.parse(dat.request.hotelAttribute);

    //console.log(dat.request.hotelAttribute);
    dispatch(
      setSearchOption({
        property: "hotelAttribute",
        data: dat.request.hotelAttribute,
      }),
    );
  }
  if (dat.request.roomType) {
    //console.log(dat.request.roomType);
    dispatch(
      setSearchOption({
        property: "roomType",
        data: JSON.parse(dat.request.roomType),
      }),
    );
  }
  if (dat.request.roomView) {
    // console.log(dat.request.roomView);
    dispatch(
      setSearchOption({
        property: "roomView",
        data: JSON.parse(dat.request.roomView),
      }),
    );
  }
  if (dat.request.recommendationrate) {
    dispatch(
      setSearchOption({
        property: "recommendationrate",
        data: dat.request.recommendationrate,
      }),
    );
  }
  if (dat.request.category) {
    dispatch(
      setSearchOption({
        property: "category",
        data: dat.request.category,
      }),
    );
  }
  if (dat.request.ratingcount) {
    dispatch(
      setSearchOption({
        property: "ratingcount",
        data: dat.request.ratingcount,
      }),
    );
  }
  if (dat.request.boardType) {
    //console.log(dat.request.boardType);
    dispatch(
      setSearchOption({
        property: "boardType",
        data: JSON.parse(dat.request.boardType),
      }),
    );
  }
  if (dat.request.duration)
    dispatch(
      setSearchOption({
        property: "duration",
        data: durationOptions[dat.request.duration],
      }),
    );
  if (dat.request.couponcode) {
    dispatch(
      setSearchOption({
        property: "couponcode",
        data: dat.request.couponcode,
      }),
    );
  }
  if (dat.request.durationkind && durationkindOptions.find((e) => e.value === dat.request.durationkind))
    dispatch(
      setSearchOption({
        property: "durationkind",
        data: durationkindOptions.find((o) => o.value === dat.request.durationkind + ""),
      }),
    );

  if (dat.request.stations) {
    let reqstats = dat.request.stations.split(",");
    let stats = [];
    for (let i = 0; i < reqstats.length; i++) {
      stats.push({
        value: reqstats[i],
        label: airportcity(reqstats[i]),
      });
    }
    dispatch(
      setSearchOption({
        property: "stations",
        data: stats,
      }),
    );
  }
  dispatch(setHotelPage(1));
  if (dat.OfferID) dispatch(setOfferId(dat.OfferID));
  if (dat.DepartureDate) dispatch(setOutbounddate(dat.DepartureDate));
  if (dat.ReturnDate) dispatch(setInbounddate(dat.ReturnDate));

  if (dat.infos) {
    dispatch(setSelectedHotel(dat.infos.HotelDictionary.Hotel[0]));
    dispatch(
      setHotelData({
        ...dat.infos,
        ...{ Offers: { Offer: dat.infos.Offers.Offer[0] } },
      }),
    );
    if (Array.isArray(dat?.infos?.Offers?.Offer) && dat.infos.Offers.Offer.length > 0) {
      dat.infos.Offers.Offer[0] = {
        ...dat.infos.Offers.Offer[0],
        dboffer: true,
      };
    }
    dispatch(setHotelOfferInfos(dat.infos));
  } else {
    search(dispatch, hotelsearch, false);
  }
  window.scrollTo(0, 0);
};

export const cookietosearch = (data, dispatch) => {
  let dat = Array.isArray(data.ret) && data.ret.length > 0 ? data.ret[0] : {};
  if (dat?.data) dat = dat.data;

  if (Array.isArray(dat.request.HotelGiataID)) {
    dispatch(
      setSelectedDestination(
        dat.request.HotelGiataID.map((e, i) => {
          return {
            label: dat.names[i],
            Name: dat.names[i],
            HotelCodes: {
              HotelGiataID: e * 1,
              label: dat.names[i],
              value: dat.names[i],
              Name: dat.names[i],
            },
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.request.CityID)) {
    dispatch(
      setSelectedDestination(
        dat.request.CityID.map((e, i) => {
          return {
            CityID: e * 1,
            label: dat.names[i],
            value: dat.names[i],
            Name: dat.names[i],
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.request.RegionID)) {
    dispatch(
      setSelectedDestination(
        dat.request.RegionID.map((e, i) => {
          return {
            RegionID: e * 1,
            label: dat.names[i],
            value: dat.names[i],
            Name: dat.names[i],
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.request.RegionGroupID)) {
    dispatch(
      setSelectedDestination(
        dat.request.RegionGroupID.map((e, i) => {
          return {
            RegionGroupID: e * 1,
            label: dat.names[i],
            value: dat.names[i],
            Name: dat.names[i],
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.setSelectedDestination) && dat.setSelectedDestination.length > 0 && dat.setSelectedDestination[0].HotelID) {
    dispatch(setSelectedDestination(dat.setSelectedDestination));
  }

  let td = {
    from: JSON.stringify(new Date(dat.request.minDate)),
    to: JSON.stringify(new Date(dat.request.maxDate)),
  };

  dispatch(setSearchOption({ property: "travelDate", data: td }));
  if (dat.request.adults)
    dispatch(
      setSearchOption({
        property: "adults",
        data: adultsOptions.find((o) => o.value === dat.request.adults + ""),
      }),
    );
  if (dat.request.children) {
    dispatch(
      setSearchOption({
        property: "children",
        data: childrenOptions.find((o) => o.value === dat.request.children + ""),
      }),
    );

    if (dat.request.childrenages) {
      let childrenages = [
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
      ];
      let tmpages = dat.request.childrenages.split(",");
      if (Array.isArray(tmpages)) {
        for (let i = 0; i < tmpages.length; i++) {
          childrenages[i] = childrenAgeOptions.find((o) => o.value === tmpages[i] + "");
        }
      }
      dispatch(
        setSearchOption({
          property: "childrenages",
          data: childrenages,
        }),
      );
    }
  }

  /*if (dat.request.touroperators) {
    dispatch(
      setSearchOption({
        property: "tourOperators",
        data: dat.request.touroperators.split(","),
      })
    );
  }
  if (dat.request.hotelAttribute) {
    console.log(dat.request.hotelAttribute)
    dispatch(
      setSearchOption({
        property: "hotelAttribute",
        data: JSON.parse(dat.request.hotelAttribute),
      })
    );
  }
  if (dat.request.roomType) {
    console.log(dat.request.roomType)
    dispatch(
      setSearchOption({
        property: "roomType",
        data: JSON.parse(dat.request.roomType),
      })
    );
  }
  if (dat.request.roomView) {
    console.log(dat.request.roomView)
    dispatch(
      setSearchOption({
        property: "roomView",
        data: JSON.parse(dat.request.roomView),
      })
    );
  }
  if (dat.request.boardType) {
    console.log(dat.request.boardType)
    dispatch(
      setSearchOption({
        property: "boardType",
        data: JSON.parse(dat.request.boardType),
      })
    );
  }*/
  if (dat.request.duration)
    dispatch(
      setSearchOption({
        property: "duration",
        data: durationOptions[dat.request.duration],
      }),
    );
  if (dat.request.stations) {
    let reqstats = dat.request.stations.split(",");
    let stats = [];
    for (let i = 0; i < reqstats.length; i++) {
      stats.push({
        value: reqstats[i],
        label: airportcity(reqstats[i]),
      });
    }
    dispatch(
      setSearchOption({
        property: "stations",
        data: stats,
      }),
    );
  }
  dispatch(setHotelPage(1));
  dispatch(setOfferId(dat.OfferID));
  //dispatch(setOutbounddate(dat.DepartureDate));
  if (dat.ReturnDate) dispatch(setInbounddate(dat.ReturnDate));
};

export const suggestiontosearch = (dat, dispatch) => {
  if (Array.isArray(dat.request.HotelGiataID)) {
    dispatch(
      setSelectedDestination(
        dat.request.HotelGiataID.map((e, i) => {
          return {
            label: dat.names[i],
            HotelCodes: {
              HotelGiataID: e * 1,
              label: dat.label,
              value: dat.value,
              Name: dat.label,
            },
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.request.CityID)) {
    dispatch(
      setSelectedDestination(
        dat.request.CityID.map((e, i) => {
          return {
            CityID: e * 1,
            label: Array.isArray(dat?.request?.CityName) && dat.request.CityName.length > i ? dat.request.CityName[i] : Array.isArray(dat.names) && dat.names.length > i ? dat.names[i] : dat.label,
            value: dat.value,
            Name: dat.label,
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.request.RegionID)) {
    dispatch(
      setSelectedDestination(
        dat.request.RegionID.map((e, i) => {
          return {
            RegionID: e * 1,
            label:
              Array.isArray(dat?.request?.RegionName) && dat.request.RegionName.length > i ? dat.request.RegionName[i] : Array.isArray(dat.names) && dat.names.length > i ? dat.names[i] : dat.label,
            value: dat.value,
            Name: dat.label,
          };
        }),
      ),
    );
  }

  if (Array.isArray(dat.request.RegionGroupID)) {
    dispatch(
      setSelectedDestination(
        dat.request.RegionGroupID.map((e, i) => {
          return {
            RegionGroupID: e * 1,
            label:
              Array.isArray(dat?.request?.RegionName) && dat.request.RegionName.length > i ? dat.request.RegionName[i] : Array.isArray(dat.names) && dat.names.length > i ? dat.names[i] : dat.label,
            value: dat.value,
            Name: dat.label,
          };
        }),
      ),
    );
  }

  /*if (dat.request.minDate && dat.request.maxDate) {
    let td = {
      from: JSON.stringify(new Date(dat.request.minDate)),
      to: JSON.stringify(new Date(dat.request.maxDate)),
    };
    dispatch(setSearchOption({ property: "travelDate", data: td }));
  }

  if (dat.request.adults)
    dispatch(
      setSearchOption({
        property: "adults",
        data: adultsOptions.find((o) => o.value === dat.request.adults + ""),
      })
    );
  if (dat.request.children) {
    dispatch(
      setSearchOption({
        property: "children",
        data: childrenOptions.find(
          (o) => o.value === dat.request.children + ""
        ),
      })
    );

    if (dat.request.childrenages) {
      let childrenages = [
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
      ];
      let tmpages = dat.request.childrenages.split(",");
      if (Array.isArray(tmpages)) {
        for (let i = 0; i < tmpages.length; i++) {
          childrenages[i] = childrenAgeOptions.find(
            (o) => o.value === tmpages[i] + ""
          );
        }
      }
      dispatch(
        setSearchOption({
          property: "childrenages",
          data: childrenages,
        })
      );
    }
  }

  if (dat.request.touroperators) {
    dispatch(
      setSearchOption({
        property: "tourOperators",
        data: dat.request.touroperators.split(","),
      })
    );
  }*/
  /*
  if (dat.request.hotelAttribute) {
    console.log(dat.request.hotelAttribute)
    dispatch(
      setSearchOption({
        property: "hotelAttribute",
        data: JSON.parse(dat.request.hotelAttribute),
      })
    );
  }
  if (dat.request.roomType) {
    console.log(dat.request.roomType)
    dispatch(
      setSearchOption({
        property: "roomType",
        data: JSON.parse(dat.request.roomType),
      })
    );
  }
  if (dat.request.roomView) {
    console.log(dat.request.roomView)
    dispatch(
      setSearchOption({
        property: "roomView",
        data: JSON.parse(dat.request.roomView),
      })
    );
  }
  if (dat.request.boardType) {
    console.log(dat.request.boardType)
    dispatch(
      setSearchOption({
        property: "boardType",
        data: JSON.parse(dat.request.boardType),
      })
    );
  }*/
  /*if (dat.request.duration && durationOptions[dat.request.duration])
    dispatch(
      setSearchOption({
        property: "duration",
        data: durationOptions[dat.request.duration],
      })
    );

  if (
    dat.request.durationkind &&
    durationkindOptions.find((e) => e.value === dat.request.durationkind)
  )
    dispatch(
      setSearchOption({
        property: "durationkind",
        data: durationkindOptions.find(
          (o) => o.value === dat.request.durationkind + ""
        ),
      })
    );

  if (dat.request.stations) {
    let reqstats = dat.request.stations.split(",");

    let stats = [];
    for (let i = 0; i < reqstats.length; i++) {
      reqstats[i] = reqstats[i].trim();
      console.log("<" + reqstats[i] + ">");
      stats.push({
        value: reqstats[i],
        label: airportcity(reqstats[i]),
      });
    }
    dispatch(
      setSearchOption({
        property: "stations",
        data: stats,
      })
    );
  }*/
  dispatch(setHotelPage(1));
};
